import script from "./CatalogImageUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./CatalogImageUpload.vue?vue&type=script&setup=true&lang=js"

import "./CatalogImageUpload.vue?vue&type=style&index=0&id=50f28d34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50f28d34"]])

export default __exports__